import axios, { AxiosResponse } from "axios";
import AxiosAPI from '@qualitas/libs';

interface IUploadDocumentAPI {
	baseURL: string | undefined;
	clientId: string;
	blobContainerName?: string;
	blobFolderName?: string;
}

export const UploadDocumentAPI = ({
	baseURL,
	clientId,
	blobContainerName = "",
	blobFolderName = "investor-documents"
}: IUploadDocumentAPI) => {
	const api = AxiosAPI({ baseURL, clientId });

	const getOcrToken = (): Promise<any> => (
		api.get("/masters-api/Logger/GetOcrToken")
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => {
				if (error.response?.data?.errorMessage) {
					throw new Error(error.response.data.errorMessage);
				}
				throw error;
			})
	);

	const extractDataFromDocument = (token: string, data: any): Promise<any> => (
		axios.post('https://n8n.qualitasfunds.com/webhook/idDocumentOCR',
			{ documentURL: data }, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
		.then((response: AxiosResponse) => {
			if (response.status !== 200) {
				throw new Error("Error");
			}
			return response.data;
		})
		.catch((error: any) => {
			if (error.response?.data?.errorMessage) {
				throw new Error(error.response.data.errorMessage);
			}
			throw error;
		})
	);

	const uploadFile = (file: File, fileName?: string): Promise<any> => {
		const formData = new FormData();
		formData.append("container", blobContainerName);
		formData.append("file", file);
		formData.append("folder", blobFolderName);
		if (fileName) {
			formData.append("fileName", fileName);
		}

		return api.post(
			"/documentsystem-api/Documents/UploadTemporaryFile",
			formData,
			{
				headers: {
					"Content-Type": "multipart/form-data",
				},
			}
		)
		.then((response: AxiosResponse) => response.data)
		.catch((error: any) => {
			if (error.response?.data?.errorMessage) {
			throw new Error(error.response.data.errorMessage);
			}
			throw error;
		});
	};

	const uploadMergedFiles = (files: File[], fileName?: string): Promise<any> => {
		const formData = new FormData();
		formData.append("container", blobContainerName);
		formData.append("folder", blobFolderName);
		if (fileName) {
			formData.append("fileName", fileName);
		}

		files.forEach((file) => {
			formData.append("files", file);
		});

		return api.post(
			"/documentsystem-api/Documents/UploadMergedTemporaryFiles",
			formData,
			{
				headers: {
					"Content-Type": "multipart/form-data",
				},
			}
		)
		.then((response: AxiosResponse) => response.data)
		.catch((error: any) => {
			if (error.response?.data?.errorMessage) {
				throw new Error(error.response.data.errorMessage);
			}
			throw error;
		});
	};

	return {
		getOcrToken,
		extractDataFromDocument,
		uploadFile,
		uploadMergedFiles,
	};
};
